export const ucFirst = (str: string): string =>
  str.length >= 2 ? `${str.charAt(0).toUpperCase()}${str.slice(1).toLowerCase()}` : str.toUpperCase();

export const htmlDecode = (input: string) => {
  const doc = new DOMParser().parseFromString(input, 'text/html');
  return doc.documentElement.textContent;
};

/**
 * Opts the whole document out of in-page browser translation (Chrome iOS
 * "Translate", Google Translate). The translation engine wraps text nodes in
 * injected `<font>` elements and mutates the DOM under React, which conflicts
 * with React 19's reconciliation and can recurse into a "Maximum call stack
 * size exceeded" crash (Sentry FLEETBACK-SELF-SERVICE-C0). The app is already
 * fully internationalized, so browser translation is redundant. Idempotent.
 */
export const disableBrowserTranslation = (): void => {
  const html = document.documentElement;
  html.setAttribute('translate', 'no');
  html.classList.add('notranslate');

  if (!document.querySelector('meta[name="google"][content="notranslate"]')) {
    const meta = document.createElement('meta');
    meta.name = 'google';
    meta.content = 'notranslate';
    document.head.appendChild(meta);
  }
};
